export const INTERNAL_PATHS = {
  EDIT: "/edit",
  CREATE: "/create",
  RUOTE_CREATE: "/:model/create",
  RUOTE_EDIT: "/:model/edit/:id",
  RUOTE_EXTENDED_EDIT: "/:model/edit/:model/:id",
  RUOTE: "/:model",
  NOT_FOUND: "/NotFound",
  HOME_DASHBOARD: "/",
  FILES: "/files",
};

export const EXTERNAL_PATHS = {
  telegram: "https://t.me/espilinter",
};
